import { useEffect, useMemo, useRef } from 'react';

import { all, equals, is } from 'ramda';

/**
 * useEffectOnceWhen hook
 *
 * @description It fires a callback once when a condition is true or become true.
 * Fires the callback at most one time.
 *
 * @param callback The callback to fire
 * @param when The condition which needs to be true
 * @see https://rooks.vercel.app/docs/useEffectOnceWhen
 */
function useEffectOnceWhen(callback, when = true) {
  const hasRunOnceRef = useRef(false);
  const callbackRef = useRef(callback);
  const whenPredicate = useMemo(() => {
    if (is(Array, when)) {
      let allConditionsPass = all(equals(true), when);
      return allConditionsPass;
    }
    return when;
  }, [when]);

  useEffect(() => {
    callbackRef.current = callback;
  });
  useEffect(() => {
    if (whenPredicate && !hasRunOnceRef.current) {
      callbackRef.current();
      hasRunOnceRef.current = true;
    }
  }, [when]);
}

export { useEffectOnceWhen };
